import script from "./SavingForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SavingForm.vue?vue&type=script&setup=true&lang=js"

import "./SavingForm.vue?vue&type=style&index=0&id=a9012ef0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9012ef0"]])

export default __exports__